import { Reducer } from 'redux';
import { ActionType } from 'typesafe-actions';
import { AddressingActions } from '../actions';
import { ActionTypes, AddressingState } from '../types';

type AddressingAction = ActionType<typeof AddressingActions>;

export const InitialAddressingState: AddressingState = {
  sites: {},
  groups: {},
  players: {},
  streams: {},
  addressingRules: [],
  selectedGroup: 0,
  selectedSite: 0,
  selectedPlayer: 0
};

export const addressing: Reducer<AddressingState> = (
  state: AddressingState = InitialAddressingState,
  action: AddressingAction
) => {
  switch (action.type) {
    case ActionTypes.FETCH_GROUPS_AND_SITES_REQUEST: {
      return { ...state, isLoading: true };
    }
    case ActionTypes.FETCH_GROUPS_AND_SITES_SUCCESS: {
      const { groups, sites, players, addressingRules } = action.payload;
      // const groups = [{ label: 'Group 123', value: 123 }, { label: 'Group 456', value: 456 }];
      // const sites = [{ label: 'Site 123', value: 123 }, { label: 'Site 456', value: 456 }];
      return {
        ...state,
        isLoading: false,
        groups,
        sites,
        players,
        addressingRules,
        selectedGroup: 0,
        selectedSite: 0,
        selectedPlayer: 0
      };
    }
    case ActionTypes.FETCH_GROUPS_AND_SITES_ERROR: {
      return { ...state, isLoading: false, loadingError: action.payload };
    }
    case ActionTypes.SELECT_GROUP: {
      return { ...state, selectedSite: 0, selectedGroup: action.payload };
    }
    case ActionTypes.SELECT_SITE: {
      return { ...state, selectedSite: action.payload };
    }
    case ActionTypes.SELECT_PLAYER: {
      return { ...state, selectedPlayer: action.payload };
    }
    case ActionTypes.RESTORE_FILTERS_SELECTED_VALUES: {
      return {
        ...state,
        selectedGroup: action.payload.group,
        selectedSite: action.payload.site,
        selectedPlayer: action.payload.player
      };
    }
    case ActionTypes.CLEAR_FILTERS_SELECTED_VALUES: {
      return {
        ...state,
        selectedGroup: 0,
        selectedSite: 0,
        selectedPlayer: 0
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/addressing.ts